import { IEcoSplitSetting, IEcoPurchase, IEcoTransfer, IEcoAgreement, EcoAgreementStatus, EcoRepeat } from '@app-types/websocket/economy.types';
import { getWeekNum } from './DateHelper';
import TranslateNew from '@translate/TranslateNew';

const getPercentage = (accountId:number, time:number, settings:IEcoSplitSetting[]):number => {

  let i = settings.length - 1;
  while(i <= settings.length && i > -1) {
      if (settings[i].start < time) {
          const split = settings[i].split.find((s) => s.accountId === accountId);
          if (split) {return split.percentage;}
          else return 0;
      }
      i = i-1;
  }
  console.log("Bad data in settings!");
  return 0;
};

const getAgreementNotificationCount = (agreements:IEcoAgreement[], userId:number):number => {
    let notifications = 0;   
    const tn = TranslateNew.getInstance();
    
    const now = Date.now();
    const nowWeek = getWeekNum(new Date());
    const nowMonth = (new Date()).getMonth();
    const nowQuarter = tn.lang.getQuarterName((new Date()));
    const nowTerm = tn.lang.getTermName((new Date()));
    const nowYear = (new Date()).getFullYear();
    
    for (const agreement of agreements) {
        if (agreement.closed) {
            continue;
        } else if (agreement.seenBy.indexOf(userId) === -1
            && !(agreement.status === EcoAgreementStatus.DELETED || agreement.status === EcoAgreementStatus.REJECTED)) {
                notifications++;
        } else if ((agreement.status === EcoAgreementStatus.DELETED || agreement.status === EcoAgreementStatus.REJECTED)
            && agreement.archivedBy.indexOf(userId) === -1) {
                notifications++;
        } else if ((agreement.status === EcoAgreementStatus.AWAITING_RESPONSE)
            && agreement.responses.findIndex((response) => response.account === userId) === -1) {
                notifications++;
        } else if (agreement.status === EcoAgreementStatus.APPROVED || agreement.status === EcoAgreementStatus.PRE_APPROVED) {
            if (agreement.closed === false && (agreement.responsible.length === 0 || agreement.responsible.includes(userId))) {

                if (agreement.repeat === EcoRepeat.WEEKLY) {
                    const week = getWeekNum(new Date(agreement.forDate));
                    if (week === nowWeek) {
                        notifications++;
                    } else {
                        if (agreement.forDate < now) {
                            notifications++;
                        }
                    }
                } else if (agreement.repeat === EcoRepeat.MONTHLY) {
                    const month = (new Date(agreement.forDate)).getMonth();
    
                    if (month === nowMonth) {
                        notifications++;
                    } else {
                        if (agreement.forDate < now) {
                            notifications++;
                        } 
                    }
                } else if (agreement.repeat === EcoRepeat.QUARTERLY) {
                    const quart = tn.lang.getQuarterName((new Date(agreement.forDate)));
                    if (quart === nowQuarter) {
                        notifications++;
                    } else {
                        if (agreement.forDate < now) {
                            notifications++;
                        }
                    }
                } else if (agreement.repeat === EcoRepeat.TERM) {
                    const term = tn.lang.getTermName((new Date(agreement.forDate)));
                    if (term === nowTerm) {
                        notifications++;
                    } else {
                        if (agreement.forDate < now) {
                            notifications++;
                        }
                    }
                } else if (agreement.repeat === EcoRepeat.YEARLY) {
                    const year = (new Date(agreement.forDate)).getFullYear();
                    if (year === nowYear) {
                        notifications++;
                    } else {
                        if (agreement.forDate < now) {
                            notifications++;
                        }
                    }
                } else  {
                    notifications++;
                } 
            }
        }
    }
    return notifications;
}

const getPurchaseBalance = (purchase:IEcoPurchase, userId:number, settings:IEcoSplitSetting[]):number => {
  const mySplit = purchase.split.find((spl) => spl.accountId === userId);
  const myPercentage = (mySplit === undefined)?0:mySplit.percentage;
  const howMuchIShouldPay = (myPercentage*purchase.amount)/100;
  const howMuchIDidPay = (purchase.paidBy === userId)
      ?(purchase.fromSharedAccount
          ?(purchase.amount * (getPercentage(userId, purchase.date,settings)/100))
          :purchase.amount)
      :(purchase.fromSharedAccount
          ?(purchase.amount * (getPercentage(userId, purchase.date,settings)/100))
          :0);
  return (howMuchIDidPay - howMuchIShouldPay);
};

// A transfer can be booked in a different month from when it was created.
const getTransferBookingDate = (transfer:IEcoTransfer):number =>
    transfer.booking && transfer.booking > 0 ? transfer.booking : transfer.date;

// Items deleted before deletedBy was recorded fall back to seenBy: deleting
// resets it to [deleter] and later views only append.
const isDeletedByNonCreator = (item:IEcoPurchase|IEcoTransfer):boolean => {
    if (!item.deleted) { return false; }
    const deletedBy = item.deletedBy ? item.deletedBy : item.seenBy[0];
    return deletedBy !== undefined && deletedBy !== item.creator;
};

const getTransferBalance = (transfer:IEcoTransfer, userId:number, settings:IEcoSplitSetting[]):number => {
    let balance = 0;
    if (transfer.to > 0 && transfer.from > 0 && transfer.to !== transfer.from) {
        balance = transfer.sum;
        if (transfer.from !== userId) {
            balance = -balance;
        }
    } else if (transfer.to === 0 && transfer.from === 0) {
        balance = 0;
    } else if (transfer.to === 0) {
        balance = Math.round(transfer.sum * (100-getPercentage(transfer.from, transfer.date, settings)))/100;
        if (transfer.from !== userId) {
            balance = -balance;
        }
    } else if (transfer.from === 0) {
        balance = -Math.round(transfer.sum * (100-getPercentage(transfer.to, transfer.date, settings)))/100;
        if (transfer.to !== userId) {
            balance = -balance;
        }
    }
    return balance;
};


export { getTransferBookingDate, getPercentage, getPurchaseBalance, getTransferBalance, getAgreementNotificationCount,
    isDeletedByNonCreator};



// WEBPACK FOOTER //
// ./src/helpers/EconomyHelper.tsx